<template>
  <pt-cps-payment class="pt-cps-payment__withData" :pageSize="pageSize" ref="table" :exportLoading="exportLoading" @exportCPS="exportCPS"
  :isValidateCompany="isValidateCompany" :companyList="companyList"></pt-cps-payment>
</template>

<script>
import PtCpsPayment from './index'
// import { dataExport } from 'utils/formUtils'
export default {
  name: 'pt-cps-payment__withData',
  components: {
    'pt-cps-payment': PtCpsPayment
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      pageSize: 10,
      exportLoading: false,
      companyList: [],
      isValidateCompany: null
    }
  },
  methods: {
    exportCPS (val) {
      let data = {
        ...val,
        pageableParam: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.exportLoading = true
      this.$store.dispatch('exportCpsPaymentList', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('导出缴费记录成功')
      }).catch(err => {
        console.error(err)
        this.exportLoading = false
        this.$message.error(typeof (err) === 'string' ? err : '导出缴费记录失败')
        // this.$message.error(err || '导出缴费记录失败')
      })
    },
    // 获取分公司列表
    findBranchCompany () {
      this.$store.dispatch('findBranchCompany').then(res => {
        this.companyList = res.data
      }).catch(err => {
        console.error(err || '获取分公司列表失败')
        this.$message.error(typeof (err) === 'string' ? err : '导出缴费记录失败')
      })
    },
    isCompanyValide () {
      this.$store.dispatch('isCompanyValide').then(res => {
        this.isValidateCompany = res.data
      }).catch(err => {
        this.$message.error(typeof (err) === 'string' ? err : '导出缴费记录失败')
      })
    }
  },
  created () {
    this.findBranchCompany()
    this.isCompanyValide()
  }
}
</script>
